import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: "",
  loading: false,
}

export const EventIDSlice = createSlice({
  name: 'EventID',
  initialState,
  reducers: {
   
    Event_ID_success: (state, action) => {

      state.value = action.payload;
      state.loading = false;
      
    }
  }
})

// Action creators are generated for each case reducer function
export const {Event_ID_success } = EventIDSlice.actions

export default EventIDSlice.reducer